<template>
  <div>
    <div class="header_content">
      <div class="title">
        <img
          class="logo"
          src="../../assets/img/newLogo.png"
          alt=""
          @click="indexBtn"
        />
        <div v-if="agentWebName" class="location_box">
          <i class="el-icon-location-information"></i>{{ agentWebName }}
        </div>
        <div class="menu">
          <div class="nav">
            <p class="p_active" @click="indexBtn">
              <img src="../../assets/img/home.png" alt="" /> 首页
            </p>
            <p>
              <!-- 申请保函 -->
              <el-dropdown @command="applyFor">
                <a class="el-dropdown-link">
                  申请保函<i class="el-icon-arrow-down el-icon--right"></i>
                </a>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="01">投标保函</el-dropdown-item>
                  <el-dropdown-item command="02">履约保函</el-dropdown-item>
                  <el-dropdown-item command="04">预付款保函</el-dropdown-item>
                  <el-dropdown-item command="03">质量保证保函</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
            <span></span>
          </div>
          <!-- 登录后 -->
          <div class="login_account">
            <div class="account_box" @click="userMsgBtn">
              <div class="cion_box"><i class="el-icon-s-custom"></i></div>
              <span>{{ user.name }} 的企业主页</span>
            </div>
            <div class="esc_box" @click="logoutSubmit">退出</div>
          </div>
        </div>
      </div>
    </div>
    <el-container :style="{ height: heightN }">
      <el-aside width="220px">
        <el-menu
          :default-active="active"
          class="el-menu-vertical-demo"
          :unique-opened="true"
        >
          <el-menu-item index="1" @click="indexBtn">
            <i class="el-icon-s-home"></i>
            <span slot="title">网站首页</span>
          </el-menu-item>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-folder-opened"></i>
              <span>保函管理</span>
            </template>
            <el-menu-item index="21" @click="bidBondAdmin"
              >保函列表</el-menu-item
            >
            <!-- <el-menu-item index="22" @click="contractAdmin">履约、预付保函</el-menu-item> -->
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>发票管理</span>
            </template>
            <el-menu-item index="31" @click="titleAdmin">抬头管理</el-menu-item>
            <el-menu-item index="32" @click="invoiceAdmin"
              >发票申请</el-menu-item
            >
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">
              <i class="el-icon-setting"></i>
              <span>设置</span>
            </template>
            <el-menu-item index="41" @click="enterpriseMsgAdmin"
              >企业信息</el-menu-item
            >
            <el-menu-item index="43" @click="etpLegaMsgAdmin"
              >法人信息</el-menu-item
            >
            <el-menu-item index="42" @click="idMsgAdmin">账号信息</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { getAgent } from '@/api/agent/agent'
import { SITE_KEY, TOKEN_KEY, WEB_USER } from '@/utils/constant'
import { uasReg, uasLogin, uasResetPwd } from '@/api/user/uas'
import { detailU, loginOut } from '@/api/user/user'
import { updateC } from '@/api/user/company'
import SendSmsCode from '@/components/SendSmsCode'
import mainDataAddr from '../MainData/mainDataAddr.vue'
export default {
  data() {
    return {
      agentWebName: sessionStorage.getItem('agentWebName') || '',
      user: {},
      active: '31',
      heightN: window.innerHeight + 'px'
    }
  },
  mounted() {
    console.log(this.$route.path)
    if (!window.sessionStorage.getItem(TOKEN_KEY)) {
      location.href = '/'
    }
    if (this.$route.path.indexOf('/indexAdmin') > -1) {
      this.active = '1'
    }
    if (this.$route.path.indexOf('/bidBondAdmin') > -1) {
      this.active = '21'
    }
    if (this.$route.path.indexOf('/idMsgAdmin') > -1) {
      this.active = '42'
    }
    if (this.$route.path.indexOf('/titleAdmin') > -1) {
      this.active = '31'
    }
    if (this.$route.path.indexOf('/invoiceAdmin') > -1) {
      this.active = '32'
    }
    if (this.$route.path.indexOf('/enterpriseMsgAdmin') > -1) {
      this.active = '41'
    }
    if (this.$route.path.indexOf('/etpLegaMsgAdmin') > -1) {
      this.active = '43'
    }
    this.user = JSON.parse(window.sessionStorage.getItem(WEB_USER))
    console.log(this.user)
  },
  methods: {
    applyFor(command) {
      if (!sessionStorage.getItem(TOKEN_KEY)) {
        return this.$message.error('请先登录')
      }
      if (command == '01') {
        this.$router.push({ path: '/applyFor' })
      } else {
        this.$router.push({
          path: '/applyForMore',
          query: { guaranteeCategory: command }
        })
      }
    },
    userMsgBtn() {
      this.$router.push({ path: '/bidBondAdmin' })
    },
    logoutSubmit() {
      loginOut().then((res) => {
        if (res.success) {
          window.sessionStorage.removeItem(TOKEN_KEY)
          location.href = '/'
        } else {
          this.$message.error(res.message)
        }
      })
    },
    indexBtn() {
      this.$router.push({ path: '/' })
    },
    bidBondAdmin() {
      this.$router.push({ path: '/bidBondAdmin' })
    },
    idMsgAdmin() {
      this.$router.push({ path: '/idMsgAdmin' })
    },
    titleAdmin() {
      this.$router.push({ path: '/titleAdmin' })
    },
    invoiceAdmin() {
      this.$router.push({ path: '/invoiceAdmin' })
    },
    enterpriseMsgAdmin() {
      this.$router.push({ path: '/enterpriseMsgAdmin' })
    },
    etpLegaMsgAdmin() {
      this.$router.push({ path: '/etpLegaMsgAdmin' })
    },
    contractAdmin() {
      this.$router.push({ path: '/contractAdmin' })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/base.scss';

.header_content {
  background: #fff;
  border-bottom: 2px solid #eee;

  .title {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .logo {
      float: left;
      width: 250px;
      cursor: pointer;
    }

    .location_box {
      position: absolute;
      left: 280px;
      font-weight: bold;
      font-size: 16px;

      i {
        font-size: 20px;
        margin-right: 5px;
      }
    }

    .menu {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;

        p {
          float: left;
          margin-right: 20px;
          cursor: pointer;
        }

        p:hover {
          color: #3d8bfc;
        }

        .p_active {
          color: #3d8bfc;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 24px;
          }
        }

        span {
          float: left;
          width: 2px;
          background: #eef4fc;
          height: 20px;
          display: block;
        }
      }

      .login_register {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .login {
          margin-right: 20px;
          cursor: pointer;
        }

        .register {
          background: #3d8bfc;
          width: 80px;
          height: 25px;
          color: #fff;
          border-radius: 100px;
          text-align: center;
          line-height: 25px;
          cursor: pointer;
        }
      }

      .login_account {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #3d8bfc;

        .account_box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          cursor: pointer;

          .cion_box {
            text-align: center;
            line-height: 25px;
            width: 25px;
            height: 25px;
            color: #fff;
            border-radius: 100%;
            background: #3d8bfc;
          }

          span {
            padding-left: 5px;
          }
        }

        .esc_box {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
